import {
  BaseElementWidget,
  CustomWidget,
  SPI,
  ViewType
} from '@kunlun/dependencies';
import IndependentBillingListPage from '../../components/IndependentBillingListPage.vue';

/**
 * 独立开票列表页 - 完全自定义 Widget
 * 替换 Oinone 默认 Table 视图。
 *
 * 挂载对象为独立开票代理模型（platform / seller），其后端 queryPage 已按
 * billCategory=INDEPENDENT 收口，故本视图不会出现常规开票单。
 * 详情页复用 BillingBillDetailPage（Form 视图 layout 见 widgets/Register.ts），
 * 由该组件按 URL 模型名与返回的 billCategory 自行切换独立开票数据源与差异展示。
 */
@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Table,
    widget: ['IndependentBillingListPage']
  })
)
export class IndependentBillingListWidget extends CustomWidget {
  public initialize(props: any) {
    super.initialize(props);
    this.setComponent(IndependentBillingListPage);
    return this;
  }
}
